import React from "react";

import { Fade } from "react-awesome-reveal";

import heroPortfolio from "assets/images/hero/supermarket.png";

export default function HeroPortfolio1() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row ">
      <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
        <Fade direction="up" triggerOnce>
          <h1 className="text-6xl text-orange-600 font-bold leading-tight mb-5">
            Our Services
          </h1>
        </Fade>
        <Fade direction="up" triggerOnce delay={400}>
          <p className="font-light text-xl  text-gray-400 leading-relaxed">
            We specialize in providing a wide range of high-quality groceries,
            fresh produce, and household essentials. Committed to customer
            satisfaction and sustainable sourcing, they offer a convenient
            shopping experience with affordable prices. Ago-Mart transforms
            everyday shopping into a delightful experience, offering both
            in-store and online options for their customers.
          </p>
        </Fade>
      </div>
      <div className="w-full sm:w-1/2 sm:pr-12">
        <Fade direction="up" triggerOnce>
          <img
            src={heroPortfolio}
            alt="Hero"
            className="rounded-lg shadow-xl"
          />
        </Fade>
      </div>
    </section>
  );
}
